module.exports = __webpack_public_path__ + "img/babies.2be62986.jpg";